import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';
import memoizeOne from 'memoize-one';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import { validatePassword } from '../../utils';
import PasswordValidationStatus from '../../../components/passwordvalidationstatus';

const pwdValidations = [
	'min8Chars',
	'upperLower',
	'specialChars',
	'newPasswordVerification'
];

export const getPasswordValidationStatus = memoizeOne((pwd, pwd2) => {
	let res = validatePassword(pwd);
	res.newPasswordVerification = pwd === pwd2 && (pwd || '').length > 0;
	res.valid &= res.newPasswordVerification;
	return res;
});

export default class PasswordChangeTab extends React.PureComponent {	
	render() {
		const { data, setPassword, setPasswordChangeProperty } = this.props;
		const oldPwd = data.get('oldPwd') || '';
		const pwd1 = data.get('pwd1') || '';
		const pwd2 = data.get('pwd2') || '';
		const validationStatus = getPasswordValidationStatus(pwd1, pwd2);

		return <PasswordChange>
			<PasswordValidationStatus validations={pwdValidations} validationStatus={validationStatus} />
			<Form vertical onAction={() => {
				if (validationStatus.valid) {
					setPassword();
				}
			}} key="unamePwd">
				<FormItem label={getFormItemLabel('oldPassword')} error={data.get('oldPasswordError')}>
					<TextInput
						password
						value={oldPwd}
						onChange={value => setPasswordChangeProperty('oldPwd', value)}
					/>
				</FormItem>
				<FormItem label={getFormItemLabel('newPassword')}>
					<TextInput
						password
						value={pwd1}
						onChange={value => setPasswordChangeProperty('pwd1', value)}
					/>
				</FormItem>
				<FormItem label={getFormItemLabel('newPasswordVerification')}>
					<TextInput
						value={pwd2}
						password
						onChange={value => setPasswordChangeProperty('pwd2', value)}
					/>
				</FormItem>
				<Button
					text={getPhrase('submit')}
					onAction={setPassword}
					disabled={!validationStatus.valid}
				/>
			</Form>
		</PasswordChange>;}
}

const PasswordChange = styled.div`
	width: 470px;

	.ps-formItem {
		margin-bottom: 24px;
	}
`;